import axios from "axios";
import { base_url } from "../../utils/baseUrl";

const login = async (user) => {
  const response = await axios.post(`${base_url}user/admin-login`, user);

  if (response.data) {
    localStorage.setItem("user", JSON.stringify(response.data));

    if (response.data.expiresAt) {
      localStorage.setItem("sessionExpiry", response.data.expiresAt);
    }
  }

  return response.data;
};

const forgotPassword = async (data) => {
  const response = await axios.post(
    `${base_url}user/forgot-password-token`,
    data
  );
  return response.data;
};

const resetPassword = async (data) => {
  const response = await axios.put(
    `${base_url}user/reset-password/${data.token}`,
    { password: data.password }
  );
  return response.data;
};

const createTeamUser = async (userData) => {
  const response = await axios.post(`${base_url}user/register`, userData);
  return response.data;
};

const verifyTeamOTP = async (otpData) => {
  const response = await axios.post(`${base_url}user/verify-otp`, otpData);
  return response.data;
};

const getAllUsers = async () => {
  const response = await axios.get(`${base_url}user/all-users`);
  return response.data;
};

const getAUser = async (id) => {
  const response = await axios.get(`${base_url}user/${id}`);
  return response.data;
};

const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("sessionExpiry");
  localStorage.removeItem("sessionExpiredMessage");
};

const authService = {
  login,
  logout,
  forgotPassword,
  resetPassword,
  createTeamUser,
  verifyTeamOTP,
  getAllUsers,
  getAUser,
};

export default authService;